module.exports = __webpack_public_path__ + "img/process-active.bf2d3bb1.svg";